import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.cursorUsageEvents',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.externalEventId',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.occurredAt',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.userEmail',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.client',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.repoUrl',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.conversationId',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.jiraKey',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.requestSummary',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.requestType',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.artifacts',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.linesAdded',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.estimatedHoursSaved',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.confidence',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.model',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.generationId',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.inputTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.outputTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.cacheReadTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.cacheWriteTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.totalTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.tokenSource',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.estimatedCostUsd',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.costSource',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.netRoiUsd',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.actualCursorMinutes',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.commitSha',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.project',

    'resource:data.dimensions.projects',
    'resource:data.dimensions.projects.entities.project',

    'resource:solutions.apps.cursorTracker',
    'resource:solutions.apps.cursorTracker.pages.dashboard',
    'resource:solutions.apps.cursorTracker.pages.cursorEvents',

    'resource:solutions.mosaic.pages.cursorTracker.dashboard',
    'resource:solutions.mosaic.pages.cursorTracker.cursorEvents',

    'resource:solutions.mosaic.widgets.cursorTracker.cursorEventTable',
    'resource:solutions.mosaic.widgets.cursorTracker.totalCursorEvents',
    'resource:solutions.mosaic.widgets.cursorTracker.netRoiByProject',
    'resource:solutions.mosaic.widgets.cursorTracker.estimatedCursorCost',
    'resource:solutions.mosaic.widgets.cursorTracker.cursorNetRoi',
    'resource:solutions.mosaic.widgets.cursorTracker.cursorHoursSaved',
    'resource:solutions.mosaic.widgets.cursorTracker.recentValueCreatingEvents',
  ],
  description:
    'A package containing entities and resources for tracking Cursor usage, estimated hours saved, cost, and net ROI across projects.',
  name: 'Cursor Tracker',
} as const satisfies core.quiver.Package
